import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  CustomForm,
  CustomFormControllerApi,
  GetAllCustomFormsFormTypeEnum,
} from "../../services";
import { Identified } from "../../types/sdk-types";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface UseProviderGroupListProps {
  pagination: DGT_Pagination;
  xTENANTID?: string;
  searchKey?: string;
  gridSorting?: GridSortItem[];
  formType?: GetAllCustomFormsFormTypeEnum;
  specialities?: string;
}

/**
 * @author Rajkumar Rathod
 */
export function useFormBuilderList({
  pagination,
  xTENANTID,
  gridSorting,
  searchKey,
  formType,
  specialities,
}: UseProviderGroupListProps): useBaseContent<Identified<CustomForm>> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;

  return useQuery({
    queryKey: [
      "form-builder-list",
      pageSize,
      pageIndex,
      gridSorting,
      xTENANTID,
      searchKey,
      formType,
      specialities,
    ],

    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      new CustomFormControllerApi(getConfigObject())
        .getAllCustomForms(
          pageIndex, //page
          pageSize, //pageSize
          sortBy, // sortBy
          sortDirect, // sortDirection
          formType, //formType
          searchKey, //searchString
          undefined, //active
          false, //archive
          xTENANTID
        )
        .then((res) => asPaginatedContent<Identified<CustomForm>>(res?.data)),
  });
}
